import React, { useEffect } from "react";
import moment from "moment";
import { Row } from "antd";
import { CustomLabel } from "../../../../Common/style";
import { scrollToTop } from "../../../../Utils";
import AppointmentCard from "../../../../Components/AppointmentCard";
import PAGE_CONSTANTS from "../constant";
import CONSTANTS from "../../../../Utils/constant";
import { AppointmentDetails } from "../../CommonData";
import "./bookedVisits.css";

const BookedVisitsTemplate = ({bookedAppointment}) => {
  const {
    Application_Number
  } = AppointmentDetails()

  const getAddress = (appointment) => {
    const getValue = (val, prefix=",") => {
      return val ? `${prefix} ${val}` : '';
    }
    if(appointment?.visit_type === PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE){
      return appointment?.dcAddress;
    }
    else {
      return `${getValue(appointment?.home_address1,'')}${getValue(appointment?.home_address2)}${getValue(appointment?.Home_address3)}${getValue(appointment?.Home_city)}${getValue(appointment?.Home_pincode)}`
    }
  }
  const formattedAppointmentData = (appointment) => {
   return {
    name: `${appointment?.insured_First_name || ''} ${appointment?.insured_Middle_name || ''} ${appointment?.insured_Last_name || ''}`,
    appNo: Application_Number,
    address: getAddress(appointment),
    date: moment(moment(appointment?.Appointment_preferred_date1)).format(CONSTANTS?.FORMAT_DOB),
    time: appointment?.Appointment_preferred_time1,
    mobile: appointment?.insured_mobile_number,
    email: appointment?.insured_emailid,
    type: appointment?.visit_type,
    clinicName: appointment?.preferred_dc_name,
  }
  }

  useEffect(() => {
    scrollToTop();
  },[])
  return (
    <>
      <Row className="booked-appointment-heading">
        <CustomLabel font_size="24" font_weight="bold">
          {PAGE_CONSTANTS?.YOUR_APPOINTMENT_CONFIRMED_TITLE}
        </CustomLabel>
      </Row>
      <Row gutter={[0, 20]}>
        {bookedAppointment ?
          <AppointmentCard {...formattedAppointmentData(bookedAppointment)} />
         : null}
      </Row>
    </>
  );
};

export default BookedVisitsTemplate;
